import { Money } from '@graphcommerce/magento-store'
import { extendableComponent } from '@graphcommerce/next-ui'
import { Typography, TypographyProps, Box } from '@mui/material'
import { ProductListPriceFragment } from './ProductListPrice.gql'
import { Trans } from '@lingui/react'

const { classes, selectors } = extendableComponent('ProductListPrice', [
  'root',
  'discountPrice',
] as const)

type ProductListPriceProps = ProductListPriceFragment & Pick<TypographyProps, 'sx'> & { hasStartingFrom?: boolean }

export function ProductListPrice(props: ProductListPriceProps) {
  const { regular_price, final_price, hasStartingFrom = true, sx } = props

  return (
    <Typography component='div' variant='body1' className={classes.root} sx={sx}>
      <Typography variant='body2' color={'#808080'} noWrap>
      {hasStartingFrom && <Typography component='p' variant='caption' color='gray.400'>
        <Trans id="priceStartingFrom">A partire da</Trans>
      </Typography>}
      </Typography>
      {regular_price.value !== final_price.value && (
        <Box
          component='span'
          sx={{
            textDecoration: 'line-through',
            color: 'text.disabled',
            marginRight: '8px',
          }}
          className={classes.discountPrice}
        >
          <Money {...regular_price} />
          
        </Box>
      )}
      
      <Typography component='p' fontWeight={'bold'} variant={'price'} >
        <Money {...final_price} />
      </Typography>
      <Typography component='p' variant='body1' color='text.disabled' marginTop={'-15px'}>
        <Trans id="addIva" />
      </Typography>
    </Typography>
  )
}

ProductListPrice.selectors = selectors
